import React from 'react';
import * as Yup from 'yup';
import { HandleFormDetail, TextInput, ArrayInput } from 'components';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import ApiServices from 'services';

const FORM_WIDTH = '500px';
export const FormDetail = ({ selected, setSelected, initData, ...props }) => {
  const createFn = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const { status } = await ApiServices.createPermissionSysFunc(values);
      if (status === 200) {
        window.UIMessage?.success('Thêm mới thành công');
        setSelected(null);
        initData();
      } else {
        window.UIMessage?.error('Thêm mới thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  const updateFn = async (values, { setSubmitting }) => {
    delete values.updatedOn;
    setSubmitting(true);
    try {
      const { data } = await ApiServices.updatePermissionSysFunc(values.id, values);
      if (data) {
        window.UIMessage?.success('Cập nhật thành công');
        setSelected(null);
        initData();
      } else {
        window.UIMessage?.error('Cập nhật thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  return (
    <>
      <HandleFormDetail
        {...{ selected, setSelected, width: FORM_WIDTH }}
        showTitleTab={
          selected?.isNew ? 'Tạo mới' : `${selected?.controllerName} - ${selected?.actionName}`
        }
      >
        <Formik
          initialValues={{
            code: '',
            controllerName: '',
            actionName: '',
            arrTagMenu: [],
            description: '',
            ...selected,
          }}
          validationSchema={Yup.object().shape({
            code: Yup.string()
              .max(15, 'Mã chỉ được nhập tối đa 15 ký tự')
              .required('Vui lòng nhập mã nhóm!!!'),
            controllerName: Yup.string().max(255).required('Vui lòng nhập controllerName'),
            actionName: Yup.string().max(255).required('Vui lòng nhập tên chức năng'),
          })}
          onSubmit={(values, { setSubmitting }) => {
            if (selected?.isNew) {
              createFn(values, { setSubmitting });
            } else {
              updateFn(values, { setSubmitting });
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <TextInput
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code}
                label="Mã"
                name="code"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                disabled={!selected?.isNew}
              />
              <TextInput
                error={Boolean(touched.controllerName && errors.controllerName)}
                helperText={touched.controllerName && errors.controllerName}
                label="controllerName"
                name="controllerName"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.controllerName}
              />
              <TextInput
                error={Boolean(touched.actionName && errors.actionName)}
                helperText={touched.actionName && errors.actionName}
                label="Tên chức năng"
                name="actionName"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.actionName}
              />
              <ArrayInput
                value={values.arrTagMenu}
                fullWidth
                onChange={handleChange}
                label="ArrTagMenu"
                name="arrTagMenu"
              />
              <TextInput
                error={Boolean(touched.description && errors.description)}
                helperText={touched.description && errors.description}
                label="Mô tả"
                name="description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
              />
              <Box sx={{ py: 2 }}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="small"
                  type="submit"
                  variant="contained"
                >
                  {selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </HandleFormDetail>
    </>
  );
};
